import { Row } from 'antd';
import styled from 'styled-components';
import { Tag } from 'antd';

export const FilterTag = styled(Tag)`
  font-size: 13px;
`;

export const FilterRow = styled(Row)`
  margin-top: 10px;
  margin-bottom: 30px;
  svg {
    font-size: 25px;
    cursor: pointer;
    margin-left: 31px;
    > path {
      color: #cfd8dc;
    }
    @media (max-width: 768px) {
      margin-left: 15px;
      font-size: 20px;
    }
  }
  .anticon.selected path {
    color: #009de6;
  }
  .ant-tag {
    margin-right: 30px;
    padding: 5px 10px;
    cursor: pointer;
    &:hover {
      border: 1px solid #e5ebee;
      background-color: #d3f1ff;
      color: #009de6;
    }
    &.selected {
      color: #ffffff;
      background-color: #009de6;
    }
    @media (max-width: 768px) {
      margin-right: 10px;
      padding: 2px 6px;
    }
    :last-of-type {
      margin-right: 0;
    }
  }
  .search-icon-container {
    @media (max-width: 768px) {
      margin-right: 10px;
    }
    > svg {
      margin-left: 0;
    }
  }
  .search-menu-popup {
    @media (max-width: 768px) {
      margin-top: 15px;
    }
  }
`;
